import styled from 'styled-components';
import ReactModal from 'react-modal';
import Button from '../../../../../components/Button';
import Input from '../../../../../components/Input';
import { useState } from 'react';

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    padding: 0,
    border: 'none',
    borderRadius: '24px'
  },
  overlay: {
    background: 'rgba(0, 0, 0, 0.5)',
    zIndex: '9999'
  }
};

export function PasswordModal({
  idPrefix,
  isOpen,
  onClose,
  image,
  onConfirm,
  isLoading,
  title,
  description,
  children,
  withActions = true,
  submitLabel = 'Yes',
  cancelLabel = 'No',
  ...props
}) {
  const [pwd, setPwd] = useState();
  const rootId = idPrefix || 'password-modal';

  const handleSubmit = e => {
    e.preventDefault();
    if (!pwd?.trim()) return;

    onConfirm(pwd);
  };

  return (
    <ReactModal
      id={rootId}
      isOpen={isOpen}
      onRequestClose={() => onClose()}
      contentLabel="Example Modal"
      style={props.customStyles || customStyles}
    >
      <Wrapper id={`${rootId}-wrapper`} style={props.containerStyle}>
        <Body id={`${rootId}-body`} style={props.wrapperStyle} onSubmit={handleSubmit}>
          {image && <Image id={`${rootId}-image`} src={image} width={212} height={229} />}
          {title && (
            <Title id={`${rootId}-title`} dangerouslySetInnerHTML={{ __html: title }}></Title>
          )}
          {description && (
            <Text
              id={`${rootId}-description`}
              dangerouslySetInnerHTML={{ __html: description }}
            ></Text>
          )}

          <Box id={`${rootId}-input-box`}>
            <Input
              id={`${rootId}-input`}
              placeholder="Enter password"
              boxClass="inputWrapper"
              type="password"
              label="Password"
              value={pwd}
              onChange={e => setPwd(e.target.value)}
            />
          </Box>

          {withActions && (
            <Buttons id={`${rootId}-actions`}>
              <Button
                id={`${rootId}-cancel`}
                className="cancel"
                onClick={() => onClose()}
                variant="outlined"
                type="button"
              >
                {cancelLabel}
              </Button>
              <Button
                id={`${rootId}-confirm`}
                isLoading={isLoading}
                disabled={isLoading}
                onClick={handleSubmit}
                type="submit"
              >
                {submitLabel}
              </Button>
            </Buttons>
          )}
        </Body>
      </Wrapper>
    </ReactModal>
  );
}

export const Wrapper = styled.div`
  min-width: 563px;
  width: 563px;
  border-radius: 24px;
  //   background-color: #edf0f5;
  //   padding: 16px;
  overflow: hidden;
`;

export const Body = styled.form`
  width: 100%;
  border-radius: 12px;
  background-color: #fff;
  display: flex;
  align-items: center;
  flex-direction: column;
  //   padding: 48px 95px;
`;

export const Buttons = styled.div`
  display: flex;
  width: 100%;
  gap: 16px;
  margin-top: 16px;
  padding: 32px;
  border-top: 1px solid #e5e7eb;

  button {
    width: 49%;
  }

  .cancel {
    background-color: #f3f3f3;
    border-color: #f3f3f3;
    color: #2b313d;
  }
`;

export const Title = styled.p`
  font-size: 20px;
  font-size: 24px;
  font-weight: 700;
  color: #5c5d61;
  margin-top: 14px;
  text-align: center;
`;

export const Text = styled.p`
  font-size: 16px;
  line-height: 24px;
  color: #2b313d;
  margin-top: 14px;
  padding-bottom: 16px;
  border-bottom: 1px solid #cdd4df;
  text-align: center;
`;

export const Image = styled.img`
  width: 212px;
  height: 229px;
  object-fit: contain;
  margin-top: 32px;
`;

export const Box = styled.div`
  width: 100%;
  margin-top: 50px;
  padding: 32px;

  input {
    background: transparent;
  }

  .inputWrapper {
    background: #b4c0cc26;
  }
`;
